import { createSelector } from '@reduxjs/toolkit';

import { IeltsInCentreNavigation } from '@britishcouncil/common-store';

import { RootState } from 'store';

const getNavigationContextIds = createSelector(
  (state: RootState) => state.navigation.activeOrganisation?.id,
  (state: RootState) => state.navigation.activeCountry?.id,
  (state: RootState) => state.navigation.activeCentre?.id,
  (state: RootState) => state.navigation.activeLocation?.id,
  (organisationId, countryId, centreId, locationId) => ({
    organisationId,
    countryId,
    centreId,
    locationId,
  })
);

const getNavigationContextNames = createSelector(
  (state: RootState) => state.navigation.activeOrganisation?.name,
  (state: RootState) => state.navigation.activeCountry?.name,
  (state: RootState) => state.navigation.activeCentre?.name,
  (state: RootState) => state.navigation.activeLocation?.name,
  (organisationName, countryName, centreName, locationName) => ({
    organisationName,
    countryName,
    centreName,
    locationName,
  })
);

export const getNavigationContext = createSelector(
  getNavigationContextIds,
  getNavigationContextNames,
  (ids, names) => ({
    ...ids,
    ...names,
  })
);

export const navigationSelectors = IeltsInCentreNavigation.getSelectors(
  (state: RootState) => state.navigation
);
